var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 40,
    viewBox: "0 0 120 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__a",
    x1: "61.03%",
    x2: "26.463%",
    y1: "4.95%",
    y2: "71.926%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".657%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26.01%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.22%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.04%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__b",
    x1: "107.63%",
    x2: "-130.552%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.87%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.54%",
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__c",
    x1: "86.243%",
    x2: "-50.129%",
    y1: "30.904%",
    y2: "136.019%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-google-play_svg__d",
    x1: "-18.811%",
    x2: "42.085%",
    y1: "-11.825%",
    y2: "35.087%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.85%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.62%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.09%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M115.554 40H4.446C1.996 40 0 37.746 0 35V5c0-2.756 1.996-5 4.446-5h111.108C118.002 0 120 2.244 120 5v30c0 2.746-1.998 5-4.446 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "M115.554.8c2.055 0 3.737 1.888 3.737 4.2v30c0 2.312-1.67 4.2-3.737 4.2H4.446C2.391 39.2.71 37.312.71 35V5c0-2.312 1.67-4.2 3.737-4.2h111.108zm0-.8H4.446C1.996 0 0 2.254 0 5v30c0 2.756 1.996 5 4.446 5h111.108c2.448 0 4.446-2.244 4.446-5V5c0-2.746-1.998-5-4.446-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M63.165 13.72c-.8 0-1.476-.28-2.01-.832a2.832 2.832 0 01-.811-2.03c0-.804.273-1.486.811-2.026C61.687 8.28 62.362 8 63.163 8c.792 0 1.467.28 2.01.832.537.558.81 1.24.81 2.027-.008.807-.281 1.489-.81 2.027-.532.556-1.207.834-2.008.834zm-23.825 0a2.791 2.791 0 01-2.018-.82c-.552-.544-.832-1.23-.832-2.04 0-.809.28-1.495.832-2.037.545-.545 1.224-.82 2.018-.82.388 0 .766.076 1.127.233.356.152.644.36.858.613l.053.064-.597.587-.062-.073c-.338-.401-.79-.598-1.388-.598-.533 0-.999.19-1.383.565-.386.377-.582.871-.582 1.47 0 .597.196 1.091.582 1.468.384.375.85.565 1.383.565.57 0 1.048-.19 1.42-.565.222-.22.358-.53.407-.92H39.24v-.825h2.74l.01.075c.02.14.04.283.04.415 0 .761-.23 1.376-.684 1.83-.516.54-1.19.813-2.007.813zm31.678-.117h-.845l-2.588-4.14.022.745V13.6h-.844V8.12h.964l.026.041 2.433 3.9-.022-.743V8.119h.854v5.484zm-14.201 0h-.856V8.944h-1.485V8.12H58.3v.825h-1.485v4.659h.003zm-3.038 0h-.853V8.119h.853v5.484zm-4.797 0h-.854V8.944h-1.484V8.12h3.822v.825h-1.484v4.659zm-2.879-.01H42.83V8.12h3.273v.825h-2.417v1.504h2.181v.817h-2.181v1.504h2.417v.825zm15.679-1.272c.382.382.845.574 1.383.574.554 0 1.006-.188 1.383-.574.375-.375.565-.867.565-1.46s-.19-1.088-.563-1.46a1.892 1.892 0 00-1.383-.574c-.554 0-1.006.188-1.38.574-.376.375-.565.867-.565 1.46s.187 1.087.56 1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M60.264 21.259c-2.084 0-3.774 1.582-3.774 3.763 0 2.162 1.7 3.763 3.774 3.763 2.085 0 3.774-1.592 3.774-3.763 0-2.181-1.69-3.763-3.774-3.763zm0 6.035c-1.14 0-2.122-.944-2.122-2.28 0-1.357.984-2.282 2.122-2.282 1.14 0 2.122.925 2.122 2.281.003 1.346-.981 2.281-2.122 2.281zm-8.234-6.035c-2.084 0-3.774 1.582-3.774 3.763 0 2.162 1.7 3.763 3.774 3.763 2.085 0 3.774-1.592 3.774-3.763 0-2.181-1.692-3.763-3.774-3.763zm0 6.035c-1.14 0-2.122-.944-2.122-2.28 0-1.357.984-2.282 2.122-2.282 1.14 0 2.122.925 2.122 2.281 0 1.346-.981 2.281-2.122 2.281zm-9.798-4.886v1.593h3.823c-.117.893-.413 1.553-.865 2.005-.56.56-1.425 1.169-2.95 1.169-2.348 0-4.186-1.897-4.186-4.246 0-2.35 1.838-4.246 4.187-4.246 1.268 0 2.192.5 2.878 1.14l1.13-1.13c-.953-.913-2.221-1.612-4-1.612-3.222 0-5.926 2.625-5.926 5.839 0 3.223 2.702 5.839 5.927 5.839 1.74 0 3.046-.57 4.078-1.641 1.052-1.053 1.385-2.537 1.385-3.735 0-.373-.028-.708-.088-.992H42.23c.002-.003.002.017.002.017zm40.077 1.24c-.315-.845-1.268-2.398-3.223-2.398-1.936 0-3.547 1.524-3.547 3.763 0 2.113 1.593 3.763 3.735 3.763 1.72 0 2.722-1.052 3.134-1.67l-1.277-.855c-.423.628-1.012 1.04-1.848 1.04-.845 0-1.436-.383-1.829-1.14l5.031-2.084-.176-.42zm-5.13 1.257c-.04-1.453 1.129-2.192 1.965-2.192.66 0 1.208.324 1.396.796l-3.362 1.396zm-4.088 3.646h1.652V17.496h-1.652V28.55zm-2.713-6.456h-.06c-.372-.443-1.08-.845-1.985-.845-1.877 0-3.606 1.652-3.606 3.774 0 2.113 1.72 3.746 3.606 3.746.893 0 1.613-.404 1.985-.856h.06v.54c0 1.436-.768 2.21-2.005 2.21-1.013 0-1.641-.727-1.897-1.336l-1.436.6c.412.992 1.513 2.221 3.33 2.221 1.937 0 3.578-1.14 3.578-3.922v-6.752h-1.561v.62h-.01zm-1.897 5.199c-1.14 0-2.093-.953-2.093-2.27 0-1.328.952-2.29 2.093-2.29 1.13 0 2.005.973 2.005 2.29.011 1.317-.874 2.27-2.005 2.27zm21.564-9.798h-3.95V28.55h1.651v-4.186h2.3c1.83 0 3.627-1.326 3.627-3.43 0-2.105-1.79-3.44-3.628-3.44zm.048 5.325h-2.349v-3.794h2.35c1.237 0 1.936 1.021 1.936 1.897 0 .867-.708 1.897-1.937 1.897zm10.202-1.582c-1.2 0-2.437.532-2.95 1.69l1.465.609c.316-.61.894-.817 1.505-.817.856 0 1.72.512 1.74 1.425v.117c-.295-.167-.944-.423-1.72-.423-1.582 0-3.185.864-3.185 2.486 0 1.484 1.297 2.437 2.741 2.437 1.11 0 1.72-.5 2.102-1.08h.06v.855h1.593v-4.235c0-1.972-1.465-3.064-3.351-3.064zm-.207 6.055c-.54 0-1.297-.265-1.297-.944 0-.856.944-1.18 1.749-1.18.728 0 1.072.156 1.504.373a1.989 1.989 0 01-1.956 1.751zm9.368-5.819l-1.897 4.796h-.06l-1.965-4.796h-1.778l2.949 6.704-1.68 3.725h1.72l4.537-10.429h-1.826zm-14.872 7.076h1.652V17.496h-1.652V28.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__a)",
    d: "M.404.348C.148.624 0 1.045 0 1.597v19.559c0 .551.148.972.412 1.237l.069.06 10.958-10.959v-.245L.472.29l-.068.06z",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__b)",
    d: "M15.085 15.158l-3.655-3.655v-.256l3.655-3.655.08.049 4.323 2.457c1.238.697 1.238 1.848 0 2.554l-4.323 2.458-.08.048z",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__c)",
    d: "M11.43 11.375L.404 22.402c.403.432 1.08.48 1.837.06l12.924-7.352-3.735-3.735z",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-google-play_svg__d)",
    d: "M15.165 7.64L2.24.3C1.484-.132.805-.073.404.36L11.43 11.374l3.735-3.734z",
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M24.085 24.03L11.25 31.322c-.717.413-1.357.384-1.77.01l-.068.068.069.06c.412.372 1.052.403 1.769-.01l12.924-7.34-.089-.08z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M28.488 21.524l-4.414 2.506.08.08 4.323-2.458c.62-.353.924-.816.924-1.277-.037.424-.353.825-.913 1.15z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.241 9.428l17.247 9.798c.56.315.876.728.924 1.15 0-.462-.304-.925-.924-1.278L11.241 9.3C10.004 8.592 9 9.183 9 10.597v.128c0-1.416 1.004-1.996 2.241-1.297z",
    opacity: 0.25
  }))));
}

export default __webpack_public_path__ + "96da9b78.svg";
export { SvgDownloadGooglePlay as ReactComponent };